import { BASE_URL } from 'constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'DEMO_CLASSROOM_GET',
  GET_SUCCESS: 'DEMO_CLASSROOM_GET_SUCCESS',
  GET_FAILURE: 'DEMO_CLASSROOM_GET_FAILURE',
};

export const get = actions.get(
  studentClassroomId => `${BASE_URL}/classroom/demo-classrooms/${studentClassroomId}/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
